'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialUsage(inherited, location, reason, at, user, impersonator) {
  this.KA = false;
  this.xf = null;
  this.xg = null;
  this.rF = null;
  this.tP = null;
  this.xe = null;
  this.KA = inherited;
  this.xf = location;
  this.xg = reason;
  this.rF = at;
  this.tP = user;
  this.xe = impersonator;
}
export { $c_Lpresto_types$CredentialUsage as $c_Lpresto_types$CredentialUsage };
$p = $c_Lpresto_types$CredentialUsage.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialUsage;
/** @constructor */
function $h_Lpresto_types$CredentialUsage() {
}
export { $h_Lpresto_types$CredentialUsage as $h_Lpresto_types$CredentialUsage };
$h_Lpresto_types$CredentialUsage.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("CredentialUsage"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.KA ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.xf));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.xg));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.rF));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.tP));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.xe));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().al(acc, 6);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$CredentialUsage)) {
    if ((((this.KA === x$0.KA) && (this.xf === x$0.xf)) && (this.xg === x$0.xg))) {
      var x = this.rF;
      var x$2 = x$0.rF;
      var $x_2 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.tP;
      var x$4 = x$0.tP;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.xe;
      var x$6 = x$0.xe;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 6;
});
$p.s = (function() {
  return "CredentialUsage";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.KA;
      break;
    }
    case 1: {
      return this.xf;
      break;
    }
    case 2: {
      return this.xg;
      break;
    }
    case 3: {
      return this.rF;
      break;
    }
    case 4: {
      return this.tP;
      break;
    }
    case 5: {
      return this.xe;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$CredentialUsage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jv)));
}
export { $isArrayOf_Lpresto_types$CredentialUsage as $isArrayOf_Lpresto_types$CredentialUsage };
var $d_Lpresto_types$CredentialUsage = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialUsage, "presto.types$CredentialUsage", ({
  jv: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$CredentialUsage as $d_Lpresto_types$CredentialUsage };
//# sourceMappingURL=presto.types$-Credential-Usage.js.map
